module.exports = __webpack_public_path__ + "img/Middle-Semi-Elliptical-Attachment-R-47.50b5093e.png";